module.exports = __webpack_public_path__ + "static/media/mobile-post.ad5f59e9.md";